import React from "react";
import "./styles/FooterContent.scss";
import parseWithIcons from "../../utils/parseWithIcons";

const FooterContent = ({ content }) => {
  if (!content?.text) {
    return null;
  }

  return (
    <section className="footer content">
      <div className="inner">
        {content?.text && (
          <div className="text">
            <div className="text-inner">
              {parseWithIcons(content.text, "check")}
            </div>
          </div>
        )}

        <div className="footer-image">
          {content?.image && (
            <figure>
              <picture>
                <source
                  type="image/webp"
                  srcSet={content.image.localFile.childImageSharp.fluid.srcWebp}
                  data-srcset={
                    content.image.localFile.childImageSharp.fluid.srcSetWebp
                  }
                />
                <source
                  type="image/jpeg"
                  srcSet={content.image.localFile.childImageSharp.fluid.src}
                />
                <img
                  src={content.image.localFile.childImageSharp.fluid.src}
                  alt={content.image.altText}
                />
              </picture>
            </figure>
          )}
        </div>
      </div>
    </section>
  );
};

export default FooterContent;
